<template>
  <div>
    <div class="steps_body">
      <app-page-section>
        <template #title>
          {{ $t("Cargas permanentes") }}
          <app-tooltip class="m-width-m">
            {{
              $t(
                "Valor característico das cargas permanentes adicionais ao peso próprio do perfil. As cargas distribuídas e pontuais são consideradas simultaneamente."
              )
            }}
          </app-tooltip>
        </template>

        <calc-form-card-generic-load-cfg
          :item-title="$t('Carga distribuída')"
          the-type="distributed"
          the-case="permanent"
          :has-min-max-cfg="true"
        />
        <calc-form-card-point-load
          :title="$t('Carga pontual')"
          the-case="permanent"
        />
      </app-page-section>

      <app-page-section v-if="calculation.input.type !== 2">
        <template #title>
          {{ $t("Sobrecargas") }}
          <app-tooltip class="m-width-m">
            {{
              $t(
                "Valor característico das sobrecargas. As cargas distribuídas e pontuais são consideradas simultaneamente."
              )
            }}
          </app-tooltip>
        </template>

        <template #controls>
          <calc-phis-controls the-case="live" />
        </template>

        <calc-form-card-generic-load-cfg
          :item-title="$t('Carga distribuída')"
          the-case="live"
          the-type="distributed"
        />

        <calc-form-card-point-load
          :title="$t('Carga pontual')"
          the-case="live"
        />
      </app-page-section>
    </div>

    <div class="steps_nav">
      <b-button
        class="steps_nav__btn"
        @click="$emit('prev')"
        icon-left="arrow-left"
        size="is-medium"
        type="is-primary"
        inverted
        >{{ $t("Voltar") }}</b-button
      >
      <b-button
        class="steps_nav__btn"
        @click="$emit('next')"
        icon-right="arrow-right"
        size="is-medium"
        type="is-primary"
        >{{ $t("Continuar") }}</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import CalcFormCardPointLoad from "./CalcFormCardPointLoad";
import CalcFormCardGenericLoadCfg from "./CalcFormCardGenericLoadCfg";
import CalcPhisControls from "./CalcPhisControls";

export default {
  name: "CalcStepLoads",

  components: {
    CalcFormCardPointLoad,
    CalcFormCardGenericLoadCfg,
    CalcPhisControls,
  },

  computed: {
    ...mapState("calculator", ["calculation"]),
  },
};
</script>

<style lang="scss" scoped></style>

['min', 'max']
